import React from 'react';

/**
 * ObliqueTable - Data table components matching Oblique GridTable aesthetic.
 */
export function Table({ children, className = '', ...props }) {
    return (
        <div className="w-full overflow-x-auto rounded-2xl border border-[var(--border)] bg-[var(--bg-surface)] shadow-xs">
            <table className={`w-full text-left border-collapse text-[13px] ${className}`} {...props}>
                {children}
            </table>
        </div>
    );
}

export function TableHeader({ children, className = '', ...props }) {
    return (
        <thead className={`bg-[var(--bg-subtle)] border-b border-[var(--border-subtle)] text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider ${className}`} {...props}>
            {children}
        </thead>
    );
}

export function TableBody({ children, className = '', ...props }) {
    return (
        <tbody className={`divide-y divide-[var(--border-subtle)] ${className}`} {...props}>
            {children}
        </tbody>
    );
}

export function TableRow({ children, className = '', hoverable = true, ...props }) {
    return (
        <tr className={`${hoverable ? 'hover:bg-[var(--bg-subtle)] transition-colors' : ''} ${className}`} {...props}>
            {children}
        </tr>
    );
}

export function TableHead({ children, className = '', ...props }) {
    return (
        <th className={`px-4 py-3 font-semibold ${className}`} {...props}>
            {children}
        </th>
    );
}

export function TableCell({ children, className = '', ...props }) {
    return (
        <td className={`px-4 py-3.5 text-[var(--text-primary)] ${className}`} {...props}>
            {children}
        </td>
    );
}
